import { createApi } from '@reduxjs/toolkit/query/react';
import { PagedResult } from '../../types/api';
import { config } from '../../constants/config';
import { createBaseQuery } from './baseQuery';

export interface ApiRequestLog {
  id: string;
  clientId: string;
  organizationId: string;
  endpoint: string;
  controller: string;
  action: string;
  httpMethod: string;
  providerName: string;
  statusCode: number;
  executionTimeMs: number;
  timestamp: string;
  errorMessage: string;
}

export interface LogsFilters {
  page?: number;
  pageSize?: number;
  clientId?: string;
  organizationId?: string;
  startDate?: string;
  endDate?: string;
  endpoint?: string;
  statusCode?: number;
  httpMethod?: string;
}

export const logsApi = createApi({
  reducerPath: 'logsApi',
  baseQuery: createBaseQuery(`${config.apiUrl}/api`),
  tagTypes: ['ApiRequestLog'],
  endpoints: (builder) => ({
    getApiRequestLogs: builder.query<PagedResult<ApiRequestLog>, LogsFilters>({
      query: (filters) => ({
        url: '/logs/requests',
        params: filters,
      }),
      providesTags: ['ApiRequestLog'],
    }),

    getApiRequestLog: builder.query<ApiRequestLog, string>({
      query: (id) => ({
        url: `/logs/requests/${id}`,
      }),
      providesTags: ['ApiRequestLog'],
    }),

    exportApiRequestLogs: builder.mutation<Blob, LogsFilters>({
      query: (filters) => ({
        url: '/logs/requests',
        params: { ...filters, format: 'csv' },
        responseHandler: (response) => response.blob(),
      }),
    }),
  }),
});

export default logsApi;

export const {
  useGetApiRequestLogsQuery,
  useGetApiRequestLogQuery,
  useExportApiRequestLogsMutation,
} = logsApi;